import { render, staticRenderFns } from "./ConfirmListDelete.vue?vue&type=template&id=5cb54d12&scoped=true"
import script from "./ConfirmListDelete.vue?vue&type=script&lang=js"
export * from "./ConfirmListDelete.vue?vue&type=script&lang=js"
import style0 from "./ConfirmListDelete.vue?vue&type=style&index=0&id=5cb54d12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb54d12",
  null
  
)

export default component.exports